import React, { ElementType, ReactElement } from "react";
import Link from "next/link";
import { ArrowRight } from "@untitled-ui/icons-react";
import styles from "./featureGroup.module.scss";

export const FeatureGroup = (props: Props): ReactElement => {
  const BadgeIcon = props.badgeIcon;

  return (
    <section className={styles.section}>
      <div className={styles.headingContainer}>
        <div className={styles.headingAndSubheading}>
          <div className={styles.badge}>
            <BadgeIcon />
            {props.badgeText}
          </div>
          <div className={styles.headingText}>{props.title}</div>
        </div>
        <div className={styles.supportingText}>{props.supportingText}</div>
      </div>
      <div className={styles.featureContainer}>
        {props.features?.map((x, i) => {
          const { icon: Icon } = x;
          return (
            <div key={i} className={styles.feature}>
              {Icon && <Icon />}
              <div className={styles.textAndDesc}>
                <p className={styles.title}>{x.title}</p>
                <p className={styles.desc}>{x.desc}</p>
              </div>
              {x.detailLabel && x.link && (
                <Link
                  href={x.link}
                  target={x.newTab ? "_blank" : "_self"}
                  className={styles.link}
                >
                  {x.detailLabel} <ArrowRight />
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

interface Props {
  badgeText: string;
  badgeIcon: React.ElementType;
  title: string;
  supportingText: string;
  features: {
    icon: ElementType;
    title: string;
    desc: string;
    detailLabel?: string;
    link: string;
    newTab?: boolean;
  }[];
}
